import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { APP_INITIALIZER } from '@angular/core';

import { HttpClientModule, HttpClientJsonpModule, HttpClient } from '@angular/common/http';
import { HttpModule, JsonpModule } from '@angular/http';

// removido para retirar dependencias.
//import { RestserverService } from './restserver.service';
//import { ODataProviderService } from './odata-provider.service';
//import { ODataBrProvider } from './odatabr.service';
//import { Globals } from './globals.service';
//import { UsuarioService } from './usuario.service';
//import {StorageService,SessionService}  from './storage.service';
//import { LocalStorageService, SessionStorageService, LocalStorage, SessionStorage } from 'angular-web-storage';


@NgModule({
  imports: [
    CommonModule,
    HttpClientModule, HttpClientJsonpModule
  ],
  declarations: [],
  providers: [
   // RestserverService,
   // ODataProviderService,
   // UsuarioService,
  //  LocalStorageService, SessionStorageService,
  //  StorageService,
   // SessionService,
  /*  Globals,
    {
      provide: APP_INITIALIZER,
      useFactory: (ds: Globals) => function () { return ds.load() },
      deps: [Globals],
      multi: true
    },*/
    /*ODataBrProvider,
    {
      provide: APP_INITIALIZER,
      useFactory: (ods: ODataBrProvider) => function () { ods.load() },
      deps: [Globals,ODataBrProvider],
      multi: true
    },
*/
   /* UsuarioService,
    {
      provide: APP_INITIALIZER,
      useFactory: (ds: UsuarioService) => function () { return ds.load() },
      deps: [UsuarioService],
      multi: true
    },
*/
  ],
  exports:[
    HttpClientModule,
  ]
})
export class ServicesModule { }
